import { NotificationService } from '@Shared/services';

export function notifyModalError(
  notificationService: NotificationService,
  error: any
) {
  const errMessage = 'Error while sending request';
  setTimeout(() => {
    notificationService.showNotification(
      'ERROR',
      error?.Message ? error.Message : errMessage,
      'main',
      3000
    );
  }, 1000);
}

export function notifyModalSuccess(
  notificationService: NotificationService,
  message: string
) {
  setTimeout(() => {
    notificationService.showNotification(
      'SUCCESS',
      message,
      'main',
      3000,
      true
    );
  }, 1000);
}
